'use strict';

var GridToolbarConfigurationMarketAssignDirective = function GridToolbarConfigurationMarketAssignDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-configuration-market-assign.html'),
    controller: 'GridToolbarConfigurationMarketAssignController'
  };
};
GridToolbarConfigurationMarketAssignDirective.$inject = [];
module.exports = GridToolbarConfigurationMarketAssignDirective;